import { AppContextProvider } from "./contexts/AppContext";
import { PopupContextProvider } from "./contexts/PopupContext";
import { Quoter } from "./Quoter";

const App = () => {
    return (
        <AppContextProvider>
            <PopupContextProvider>
                <Quoter />
            </PopupContextProvider>
        </AppContextProvider>
    );
};

export default App;
